import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { useStyles } from '~/assets/styles';
import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import CancelButton from '~/components/core/Buttons/CancelButton';
import { updatePhoneProfile } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/phoneProfilesApi';
import TextFieldFormik from '~/components/TextFieldFormik';
import { reportAxiosError } from '~/Utils';

interface FormValues {
  name: string;
}

interface RenameProfileDialogProps {
  isOpen: boolean;
  organizationId: number;
  profileId: number;
  currentName: string;
  onClose: () => void;
  onRenamed: () => Promise<unknown> | void;
}

const RenameProfileDialog: React.FC<RenameProfileDialogProps> = ({
  isOpen,
  organizationId,
  profileId,
  currentName,
  onClose,
  onRenamed,
}) => {
  const { classes } = useStyles();

  if (!isOpen) {
    return null;
  }

  return (
    <Formik<FormValues>
      initialValues={{ name: currentName }}
      validationSchema={Yup.object().shape({
        name: Yup.string().trim().required('Name is required'),
      })}
      onSubmit={async (values, formikProps) => {
        try {
          await updatePhoneProfile(organizationId, profileId, { name: values.name.trim() });
          await onRenamed();
          onClose();
        } catch (error) {
          reportAxiosError(error);
          formikProps.setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, handleSubmit }) => (
        <CardDialog
          title="Rename phone profile"
          isDialog
          maxWidth="sm"
          fullWidth
          onClose={onClose}
          preventClose={isSubmitting}
        >
          <TextFieldFormik id="name" label="Profile name" fullWidth autoFocus />
          <div className={classes.buttonsContainer}>
            <CancelButton disabled={isSubmitting} onClick={onClose} />
            <Button
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              onClick={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              Save
            </Button>
          </div>
        </CardDialog>
      )}
    </Formik>
  );
};

export default RenameProfileDialog;
